import { useContext } from "react"
import {
  UserDataContext,
  UserDataContextHelper,
} from "../contexts/UserDataContextProvider"
import { useActiveOrgId } from "./useActiveOrgId"

const ReadWriteRoles = ["CUSTOMER", "OWNER", "USER_ADMIN"]

export const useIsReadOnly = (): boolean => {
  // !isProd && console.debug("> useIsReadOnly")
  const { userData } = useContext(UserDataContext)
  const activeOrgId = useActiveOrgId()
  if (!userData || !activeOrgId) {
    // !isProd && console.debug("useIsReadOnly: !userData || !activeOrgId -> read-only")
    return true
  }
  // !isProd && console.debug("useIsReadOnly: activeOrgId =", activeOrgId)
  const activeOrg = UserDataContextHelper.findOrg(activeOrgId, userData)
  if (!activeOrg || !activeOrg.user_role) {
    // !isProd && console.debug("useIsReadOnly: !activeOrg || !activeOrg.user_role -> read-only")
    return true
  }
  // !isProd && console.debug("useIsReadOnly: activeOrg.user_role =", activeOrg.user_role)
  if (ReadWriteRoles.includes(activeOrg.user_role)) {
    // !isProd && console.debug("useIsReadOnly: ReadWriteRoles.includes(activeOrg.user_role) -> read-write")
    return false
  }
  // !isProd && console.debug("useIsReadOnly: !userData || !activeOrgId -> read-only")
  return true
}
